module.exports = __webpack_public_path__ + "img/image-from-rawpixel-id-1078672-original.ea71bfd8.jpg";